package org.lennycodes.gradematewebsite

import com.varabyte.kobweb.compose.ui.graphics.Color
import kotlinx.coroutines.await
import org.lennycodes.gradematewebsite.util.DownloadOption
import kotlin.js.json

private const val DOWNLOADS_COLLECTION = "downloads"

private fun downloadsCol() = collection(FirebaseService.db, DOWNLOADS_COLLECTION)

/** Returns each download paired with its Firestore document ID. */
suspend fun fetchDownloadsWithIds(): List<Pair<String, DownloadOption>> {
    val snapshot = getDocs(downloadsCol()).await()
    val docs = snapshot.docs as Array<dynamic>
    return docs.map { d ->
        val data = d.data()
        val id = d.id as String
        id to DownloadOption(
            platform = data.platform as String,
            version = data.version as String,
            size = data.size as String,
            accent = hexToColor((data.accentHex ?: "#6366F1") as String),
            href = data.href as String,
            description = data.description as String
        )
    }
}

/** Returns downloads only — used by the public page. */
suspend fun fetchDownloads(): List<DownloadOption> =
    fetchDownloadsWithIds().map { it.second }

suspend fun createDownload(option: DownloadOption): String {
    val ref = addDoc(downloadsCol(), option.toFirestoreMap()).await()
    return ref.id as String
}

suspend fun updateDownload(id: String, option: DownloadOption) {
    updateDoc(doc(downloadsCol(), id), option.toFirestoreMap()).await()
}

suspend fun deleteDownload(id: String) {
    deleteDoc(doc(downloadsCol(), id)).await()
}

/** Convert a DownloadOption into a plain JS object Firestore can store. */
private fun DownloadOption.toFirestoreMap(): dynamic = json(
    "platform" to platform,
    "version" to version,
    "size" to size,
    "accentHex" to colorToHex(accent),
    "href" to href,
    "description" to description
)

/** Local hex conversion — replace with your shared helper if you have one. */
private fun colorToHex(color: Color): String {
    return try {
        val rgb = color as Color.Rgb
        val r = rgb.red.toString(16).padStart(2, '0')
        val g = rgb.green.toString(16).padStart(2, '0')
        val b = rgb.blue.toString(16).padStart(2, '0')
        "#$r$g$b".uppercase()
    } catch (e: Throwable) {
        "#6366F1"
    }
}